import { render, staticRenderFns } from "./FieldCopyLink.vue?vue&type=template&id=436d21e3&scoped=true"
import script from "./FieldCopyLink.vue?vue&type=script&lang=js"
export * from "./FieldCopyLink.vue?vue&type=script&lang=js"
import style0 from "./FieldCopyLink.vue?vue&type=style&index=0&id=436d21e3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d21e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('436d21e3')) {
      api.createRecord('436d21e3', component.options)
    } else {
      api.reload('436d21e3', component.options)
    }
    module.hot.accept("./FieldCopyLink.vue?vue&type=template&id=436d21e3&scoped=true", function () {
      api.rerender('436d21e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldCopyLink.vue"
export default component.exports